export default "__VITE_PUBLIC_ASSET__cef48058__"